<script lang="ts">
  import { onMount } from 'svelte';
  import ThreeScene from '../components/ThreeScene.svelte';
  import { keywords, videos, visualizationActions, selectedVideo, visualizationStore } from '../stores/visualization';

  onMount(() => {
    visualizationActions.setCurrentView('universe');
  });
</script>

<ThreeScene 
  videos={$videos} 
  keywords={$keywords} 
  viewType="universe" 
/>

<div class="instructions">
  <h3>Video Universe</h3>
  <p>Navigate through your videos in 3D space</p>
  <ul>
    <li>Drag to look around</li>
    <li>Scroll to zoom in/out</li>
    <li>Videos are positioned by relevance</li>
    <li>Larger videos have higher relevance scores</li>
  </ul>
</div>

{#if $visualizationStore.activeKeywordFilters.length > 0}
  <div class="filters">
    <span>Filters:</span>
    {#each $visualizationStore.activeKeywordFilters as k}
      <span class="tag">{k}</span>
    {/each}
    <button on:click={() => visualizationActions.clearFilters()} class="clear">Clear</button>
  </div>
{/if}

{#if $selectedVideo}
  <div class="video-info">
    <h4>Selected Video</h4>
    <p>Video details would appear here</p>
    <button on:click={() => visualizationActions.selectVideo(null)}>
      Close
    </button>
  </div>
{/if}

<style>
  .instructions {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 1.5rem;
    border-radius: 8px;
    max-width: 300px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .instructions h3 {
    margin: 0 0 0.5rem 0;
    color: #ff3e00;
  }

  .instructions p {
    margin: 0 0 1rem 0;
    opacity: 0.9;
  }

  .instructions ul {
    margin: 0;
    padding-left: 1.2rem;
  }

  .instructions li {
    margin-bottom: 0.3rem;
    opacity: 0.8;
    font-size: 0.9rem;
  }

  .filters {
    position: fixed;
    top: 84px;
    left: 20px;
    display: flex;
    gap: 8px;
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.1);
  }

  .tag {
    background: rgba(255, 62, 0, 0.9);
    color: #fff;
    border: none;
    border-radius: 999px;
    padding: 4px 10px;
  }

  .clear {
    background: transparent;
    color: #fff;
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 6px;
    padding: 4px 10px;
    cursor: pointer;
  }

  .video-info {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 400px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    z-index: 1001;
  }

  .video-info h4 {
    margin: 0 0 1rem 0;
    color: #ff3e00;
  }

  .video-info button {
    background: #ff3e00;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 1rem;
  }

  .video-info button:hover {
    background: #e63900;
  }

  @media (max-width: 768px) {
    .instructions {
      bottom: 10px;
      right: 10px;
      left: 10px;
      max-width: none;
      padding: 1rem;
    }

    .video-info {
      left: 10px;
      right: 10px;
      max-width: none;
      transform: translateY(-50%);
    }
  }
</style>